import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, {
  forwardRef,
  useContext,
  useImperativeHandle,
  useState,
} from "react";
import CancelIcon from "../../assets/icons/cross-bold-icon.png";
import AllNotifications from "../../json/Notifications.json";
import EastIcon from "@mui/icons-material/East";
import GlobalButton from "../button";
import { getNotifications } from "../../services/NotificationApi";
import { AppContext } from "../../lib/Context";
import moment from "moment";
import { useSelector } from "react-redux";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "600px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const NotificationDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);
  const { userData } = useContext(AppContext);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const notificationCount = useSelector(
    (state) => state.searchKeysReducer.searchKeys.currentNotificationCount
  );

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
      params?.fetch(notificationCount);
      fetchNotifications();
    },
    disable() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  const fetchNotifications = async () => {
    try {
      setIsLoading(true);
      const response = await getNotifications(userData?._id);
      if (response.data.status === "success") {
        setNotifications(response.data.data);
      } else {
        setError(true);
      }
    } catch (error) {
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const renderCard = () => {
    if (isLoading) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight={150}
        >
          <CircularProgress />
        </Box>
      );
    }

    if (error) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight={150}
        >
          <Typography color="error">
            Something went wrong. Please try again.
          </Typography>
        </Box>
      );
    }

    if (notifications.length === 0) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight={150}
        >
          <Typography>No notifications found.</Typography>
        </Box>
      );
    }

    const isNew = (dateString) => {
      const createdAt = new Date(dateString);
      const now = new Date();
      const diffInMinutes = (now - createdAt) / (1000 * 60);
      return diffInMinutes <= 60; // within the last 1 hour
    };

    return (
      <Stack spacing={1}>
        {notifications.map((val, index) => (
          <Stack
            key={index}
            p={2}
            borderRadius={2}
            bgcolor={"#EDF1F5"}
            spacing={0.5}
            sx={{ cursor: "pointer" }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography
                variant="h1"
                fontSize={"1.125rem"}
                fontWeight={600}
                color={"secondary.dark"}
              >
                {val.title}
              </Typography>
              {isNew(val.createdAt) && (
                <Box
                  bgcolor="error.main"
                  color="white"
                  px={1}
                  py={0.25}
                  borderRadius={1}
                  fontSize="0.75rem"
                  fontWeight={500}
                >
                  NEW
                </Box>
              )}
            </Stack>
            <Typography variant="body1" color={"text.gunSmoke"}>
              {val.message}
            </Typography>
            <Typography
              variant="body2"
              fontWeight={300}
              color={"text.gunSmoke"}
            >
              {moment(val.createdAt).format("DD.MM.YY [at] HH:MM")}
            </Typography>
          </Stack>
        ))}
      </Stack>
    );
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <Stack
        p={2}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Stack>
          <Typography
            variant="h1"
            fontSize={"1.5rem"}
            fontWeight={500}
            color={"secondary.dark"}
          >
            All Notifications
          </Typography>
          <Typography
            variant="body2"
            fontSize={"0.875rem"}
            fontWeight={400}
            color={"text.coolGrey"}
          >
            List of all details
          </Typography>
        </Stack>
        <IconButton onClick={handleClose}>
          <img src={CancelIcon} alt="cancel-icon" width={25} />
        </IconButton>
      </Stack>
      <DialogContent dividers>{renderCard()}</DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"custom_gradient"}
          title={"Close"}
          handleClickBtn={handleClose}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default NotificationDialog;
